/* eslint-disable */
const RandomTextGenerator = (len) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < len; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

const Crypto = (message) => {
  const cryptolen = Math.floor(Math.random() * 16) + 10;

  const cryptoHeader = cryptolen.toString().charAt(0) + RandomTextGenerator(cryptolen);
  const cryptoFooter = RandomTextGenerator(cryptolen) + cryptolen.toString().charAt(1);

  const cryptoMessage = Buffer.from(message).toString('base64');

  return cryptoHeader + cryptoMessage + cryptoFooter;
};

const Decrypto = (cryptotext) => {
  if (typeof cryptotext !== 'string') return ''
  cryptotext = cryptotext.trim();
  const cryptoHeader = cryptotext.charAt(0);
  const cryptoFooter = cryptotext.charAt(cryptotext.length - 1);
  const c1 = parseInt(cryptoHeader, 10);
  const c2 = parseInt(cryptoFooter, 10);
  if (c1 && (c2 || c2 === 0)) {
    const cryptolen = parseInt(cryptoHeader + cryptoFooter, 10);

    const tct = cryptotext.substring(cryptolen + 1, cryptotext.length - cryptolen - 1);

    const text = Buffer.from(tct, 'base64').toString();

    return text;
  }

  return null;
};

export default {
  Crypto,
  Decrypto,
};
